export default reference => `
  mutation {
    deleteSavedPayment(reference: "${reference}") {
      success
      message
    }
  }
`
